<template>
  <article class="pf-plan" :class="{ 'pf-plan--featured': plan.highlight }">
    <p v-if="plan.highlight" class="pf-plan__badge">Recommended</p>
    <h3 class="pf-plan__name">{{ plan.name }} plan</h3>
    <p class="pf-plan__price">
      <span class="pf-plan__amount">KSh {{ formattedPrice }}</span>
      <span class="pf-plan__period">/ {{ plan.period }} · per child</span>
    </p>
    <p class="pf-plan__tagline">{{ plan.tagline }}</p>

    <ul class="pf-plan__features" aria-label="Plan includes">
      <li
        v-for="module in programmeModules"
        :key="module.id"
        class="pf-plan__feature"
        :class="{ 'pf-plan__feature--included': isIncluded(module.id) }"
      >
        <i
          :class="isIncluded(module.id) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"
          aria-hidden="true"
        />
        <span>{{ module.label }}</span>
      </li>
    </ul>

    <p class="pf-plan__sports-note">
      Football · Basketball · Rugby · Volleyball · Tennis
    </p>

    <button type="button" class="pf-plan__cta" @click="$emit('select', plan.id)">
      {{ plan.cta }}
      <i class="fa-solid fa-arrow-right" aria-hidden="true" />
    </button>
  </article>
</template>

<script>
export default {
  name: "PathfinderPlanCard",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    programmeModules: {
      type: Array,
      required: true,
    },
  },
  emits: ["select"],
  computed: {
    formattedPrice() {
      return Number(this.plan.price).toLocaleString("en-KE");
    },
  },
  methods: {
    isIncluded(moduleId) {
      return this.plan.includes.includes(moduleId);
    },
  },
};
</script>

<style scoped>
.pf-plan {
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  border-radius: 18px;
  background: var(--background-color2);
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.06);
  height: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.pf-plan:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.1);
}

.pf-plan--featured {
  border-color: var(--border-color-hover);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

.pf-plan__badge {
  margin: 0 0 12px;
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--border-color-hover);
  color: var(--text-color3);
}

.pf-plan__name {
  margin: 0 0 8px;
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text-color1);
}

.pf-plan__price {
  margin: 0 0 12px;
}

.pf-plan__amount {
  font-size: clamp(1.5rem, 4vw, 1.85rem);
  font-weight: 900;
  color: var(--border-color-hover);
}

.pf-plan__period {
  display: block;
  margin-top: 4px;
  font-size: 0.88rem;
  color: var(--text-color1);
  opacity: 0.75;
}

.pf-plan__tagline {
  margin: 0 0 20px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--text-color1);
  opacity: 0.85;
}

.pf-plan__features {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  flex: 1;
}

.pf-plan__feature {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 0.95rem;
  color: var(--text-color1);
  opacity: 0.55;
}

.pf-plan__feature--included {
  opacity: 1;
  font-weight: 600;
}

.pf-plan__feature--included i {
  color: var(--border-color-hover);
}

.pf-plan__sports-note {
  margin: 0 0 20px;
  font-size: 0.82rem;
  color: var(--text-color1);
  opacity: 0.7;
}

.pf-plan__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  border-radius: 32px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  background: var(--background-color1);
  color: var(--text-color1);
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pf-plan--featured .pf-plan__cta {
  background: var(--border-color-hover);
  color: var(--text-color3);
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.pf-plan__cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}
</style>
